import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {initBlock} from './ConnectionDetailsBlockSlice';
import arrow from './images/right-arrow-icon.svg';
import ConnectionDetailsPage from './pages/ConnectionDetailsPage/ConnectionDetailsPage';
import SubscribersPage from './pages/SubscribersPage/SubscribersPage';
import CustomerServiceMessagesPage from './pages/CustomerServiceMessagesPage/CustomerServiceMessagesPage';
import {setIsBackNavigationDone, setIsListenerAdded} from './ConnectionDetailsBlockSlice';

const ConnectionDetailsBlock = (props) => {
  let currentView = null;

  useEffect(() => {
    props.initBlock({epiData: props.iContent});
  }, []);

  switch (props.page) {
    case 'subscribersPage':
      currentView = <SubscribersPage />;
      break;
    case 'connectionDetailsPage':
      currentView = <ConnectionDetailsPage />;
      break;
    case 'customerServiceMessagesPage':
      currentView = <CustomerServiceMessagesPage />;
      break;
  }

  function handleOnLinkClick() {
    window.history.back();
  }

  function handlePopState(event) {
    // The user clicked the back button
    if (!window.location.hash && !props.isBackNavigationDone) {
      props.setIsBackNavigationDone(true);
      props.setIsListenerAdded(false);
      window.removeEventListener('popstate', handlePopState);
      window.history.go(-1);
    }
  }

  useEffect(() => {
    if (!props.isListenerAdded) {
      window.addEventListener('popstate', handlePopState);
      props.setIsBackNavigationDone(false);
      props.setIsListenerAdded(true);
    }
  }, [window.location.hash]);

  return (
    <>
      {props.page == 'connectionDetailsPage' && (
        <a href='#' className='link-back' onClick={handleOnLinkClick}>
          {' '}
          <Image src={arrow} alt='icon' /> חזרה{' '}
        </a>
      )}
      <div className='page-wrapper'>{currentView}</div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    page: state.connectionDetailsBlock.page,
    isBackNavigationDone: state.connectionDetailsBlock.isBackNavigationDone,
    isListenerAdded: state.connectionDetailsBlock.isListenerAdded,
  };
};

const mapDispatchToProps = {initBlock, setIsBackNavigationDone, setIsListenerAdded};

export default connect(mapStateToProps, mapDispatchToProps)(ConnectionDetailsBlock);
